import AutorList from '../components/autores/AutorList';

export default function AutoresPage() {
  return <AutorList />;
}